import type { IconSvgObject } from './types';

const HalalLabIcon: IconSvgObject = [
  ["path", { d: "M7 3H3V21H7C7 18.2386 9.23858 16 12 16C14.7614 16 17 18.2386 17 21H21C21 16.0294 16.9706 12 12 12C10.1499 12 8.4301 12.5583 7 13.5155V3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 3C12 7.97056 16.0294 12 21 12V8C18.2386 8 16 5.76142 16 3H12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HalalLabIcon;
